module.exports = __webpack_public_path__ + "media/images/icon_right-33940bf1.svg";